// 界面文字（导航、按钮、标题）。活动、部门、成员等内容的中英文写在各自的数据文件里。
// 缺少英文时会自动显示中文。
export const translations = {
    zh: {
        nav: {
            about: "关于我们",
            departments: "部门介绍",
            events: "活动",
            gallery: "剪影",
            freshmanHandbook: "新生手册",
            contactUs: "联系我们",
            weixin: "微信公众号",
            instagram: "Instagram",
            xiaohongshu: "小红书",
            facebook: "Facebook",
        },
        home: {
            aboutTitle: "关于我们",
            aboutDescription: "NYU Tandon CSSA（全称Chinese Students and Scholars Association，即中国学生学者联合会）是NYU Tandon School of Engineering大的华人学生团体，同时也是中国驻纽约领事馆注册的学生组织。 我们面向NYU全体中国学生，以广大Tandon中国留学生为中心，致力于通过此平台为大家提供NYU校内及校外的优质资源与服务。",
            joinUs: "加入我们",
            learnMore: "了解我们",
            eventsTitle: "我们的活动",
            upcomingEvents: "活动 · 预告",
            pastEvents: "活动 · 回顾",
        },
        departments: {
            title: "我们的社团",
            description: "Tandon CSSA作为唯一一个专注于服务Tandon中国学生的官方组织，我们的团队一直在期待并欢迎更多有趣灵魂的加入！\n我们时刻关注工院最新趋势，公众平台分享干货，举办针对工院的贴心活动，让大家在异乡也能感受到家的温暖。一届又一届，每一位Tandon CSSA成员都在以自己的努力和热情为Tandon CSSA打造美好的未来。",
            eboardButton: "Eboard",
            detailsButton: "部门详情",
            detailsTitle: "部门详情",
        },
        events: {
            title: "我们的活动",
            searchYear: "年份",
            searchYearPlaceholder: "选择年份",
            searchName: "活动名称",
        },
        about: {
            executiveBoard: "Executive board",
            cabinet: "CABINET",
            board: "BOARD",
            wallOfFame: "WALL OF FAME",
            advisors: "ADVISOR COMMITTEE",
            webTeam: "Web development team",
        },
    },
    en: {
        nav: {
            about: "About Us",
            departments: "Departments",
            events: "Events",
            gallery: "Gallery",
            freshmanHandbook: "Freshman Handbook",
            contactUs: "Contact Us",
            weixin: "WeChat",
            instagram: "Instagram",
            xiaohongshu: "Xiaohongshu",
            facebook: "Facebook",
        },
        home: {
            aboutTitle: "About Us",
            aboutDescription: "NYU Tandon CSSA (full name: Chinese Students and Scholars Association) is the largest Chinese student organization at the NYU Tandon School of Engineering and is also a student organization registered with the Chinese Consulate General in New York. We serve all Chinese students at NYU, with a primary focus on Chinese international students at Tandon, and are committed to providing high-quality resources and services both on and off campus through this platform.",
            joinUs: "Join Us",
            learnMore: "More About Us",
            eventsTitle: "Our Events",
            upcomingEvents: "Upcoming Events",
            pastEvents: "Past Events",
        },
        departments: {
            title: "Our Clubs",
            description: "As the only official organization dedicated to serving Chinese students at Tandon, Tandon CSSA has always been looking forward to and welcoming more interesting individuals to join us! \nOur team constantly keeps up with the latest trends in the School of Engineering, shares valuable information on public platforms, and organizes thoughtful events tailored for the engineering community, allowing everyone to feel the warmth of home even in a foreign land. Year after year, each member of Tandon CSSA contributes their efforts and passion to creating a bright future for the organization.",
            eboardButton: "Eboard",
            detailsButton: "Department Details",
            detailsTitle: "Department Details",
        },
        events: {
            title: "Our Events",
            searchYear: "Year",
            searchYearPlaceholder: "Select year",
            searchName: "Event Name",
        },
        about: {
            executiveBoard: "Executive board",
            cabinet: "CABINET",
            board: "BOARD",
            wallOfFame: "WALL OF FAME",
            advisors: "ADVISOR COMMITTEE",
            webTeam: "Web development team",
        },
    },
};
